module.exports = __webpack_public_path__ + "static/siteVitrine_antoinePavy-02e40cccaa472befc1dd63e8374eaeea.png";